var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.searchIndex?.length &&
            _vm.searchKey?.length &&
            _vm.searchHost?.length,
          expression:
            "searchIndex?.length && searchKey?.length && searchHost?.length",
        },
      ],
      ref: "search",
      staticClass: "search--container",
      class: _vm.containerClasses,
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
        open: function ($event) {
          _vm.hideWidget = false
        },
        close: function ($event) {
          _vm.hideWidget = true
        },
      },
    },
    [
      _vm.minimizeWidget
        ? _c("a", {
            staticClass:
              "search--handle visual_menu--glass_effect textual_menu--glass_effect",
            class: _vm.searchHandleClasses,
            attrs: {
              href: "#",
              title: _vm.hideWidget ? "Open Search" : "Close Search",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.handleSearchHandleClick.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "viewport" },
        [
          _c("text-input", {
            ref: "input",
            attrs: {
              label: "Search Menu Items",
              type: "search",
              required: "",
              wide: "",
            },
            on: { focus: _vm.focusHandler },
            nativeOn: {
              input: function ($event) {
                return _vm.submitAutocomplete.apply(null, arguments)
              },
              search: function ($event) {
                return _vm.submitSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchTerm,
              callback: function ($$v) {
                _vm.searchTerm = $$v
              },
              expression: "searchTerm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "autocomplete",
          staticClass: "autocomplete_results--container",
          class: {
            "autocomplete_results--container-hide":
              !_vm.showResults || !_vm.autocompleteResults.length,
          },
          style: { "max-height": _vm.autocompleteMaxHeight },
        },
        [
          _vm._l(_vm.autocompleteResults, function (result, index) {
            return _c(
              "li",
              {
                key: index,
                on: {
                  click: function ($event) {
                    return _vm.handleResultClick(result)
                  },
                },
              },
              [
                _c("div", { staticClass: "autocomplete_results--content" }, [
                  result.hasOwnProperty("_formatted") &&
                  result._formatted.hasOwnProperty("mi_title")
                    ? _c("h4", {
                        domProps: {
                          innerHTML: _vm._s(result._formatted.mi_title),
                        },
                      })
                    : result.mi_title.length
                    ? _c("h4", [_vm._v(_vm._s(result.mi_title))])
                    : _vm._e(),
                  _vm._v(" "),
                  result.hasOwnProperty("_formatted") &&
                  result._formatted.hasOwnProperty("mi_subtitle")
                    ? _c("h5", {
                        domProps: {
                          innerHTML: _vm._s(result._formatted.mi_subtitle),
                        },
                      })
                    : result.mi_subtitle.length
                    ? _c("h5", [_vm._v(_vm._s(result.mi_subtitle))])
                    : _vm._e(),
                  _vm._v(" "),
                  result.hasOwnProperty("_formatted") &&
                  result._formatted.hasOwnProperty("mi_description")
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(result._formatted.mi_description),
                        },
                      })
                    : result.mi_description.length
                    ? _c("p", [_vm._v(_vm._s(result.mi_description))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass:
                    "item_button--container item_button--container-view material-icons",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      _vm.$emit("view-menu-item", result.mi_id)
                      _vm.showResults = false
                      _vm.hideWidget = true
                    },
                  },
                }),
                _vm._v(" "),
                _vm.$store.state.selectedMenuItemIds.length
                  ? _c("a", {
                      staticClass:
                        "item_button--container item_button--container-select material-icons",
                      class: {
                        "item_button--container-active":
                          -1 !==
                          _vm.$store.state.selectedMenuItemIds.indexOf(
                            result.mi_id
                          ),
                      },
                      attrs: {
                        href: "#",
                        title:
                          -1 !==
                          _vm.$store.state.selectedMenuItemIds.indexOf(
                            result.mi_id
                          )
                            ? "Remove favorite item"
                            : "Add favorite item",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.$store.commit("toggleMenuItemSelected", [
                            result.mi_id,
                            _vm.menu?.menu_id || 0,
                          ])
                        },
                      },
                    })
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.autocompleteResults.length
            ? _c("li", [_c("i", [_vm._v("No Results Found")])])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }